module.exports = __webpack_public_path__ + "img/pd-img21.83f139a2.png";